<template>
  <div>
    <TravelCoverage v-if="travelStep === 1"></TravelCoverage>
    <TravelQuotations v-if="travelStep === 2"></TravelQuotations>
    <TravelPersonalData v-if="travelStep === 3"></TravelPersonalData>
    <TravelAuth v-if="travelStep === 4"></TravelAuth>
  </div>
</template>

<script>
import TravelCoverage from "./TravelCoverage";
import TravelQuotations from "./TravelQuotations";
import TravelPersonalData from "./TravelPersonalData";
import TravelAuth from "./TravelAuth";

import {IS_LOGGED_IN, NEXT_STEP, PREV_STEP} from "../store/travel.module";
import {mapGetters} from "vuex";
import EventBus from '../eventbus';

export default {
  name: "TravelFlow",
  components: {TravelAuth, TravelPersonalData, TravelQuotations, TravelCoverage},
  computed: {
    ...mapGetters(['travelStep'])
  },
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.$store.dispatch(IS_LOGGED_IN);
      EventBus.$on('next-step', this.nextStep);
      EventBus.$on('prev-step', this.prevStep);
    },
    nextStep() {
      this.$store.commit(NEXT_STEP)
    },
    prevStep() {
      this.$store.commit(PREV_STEP)
    }
  }
}
</script>

<style scoped>

</style>